import { gql, TypedDocumentNode } from '@apollo/client'
import type { WorkObstructionFragment } from './__generated__/WorkObstructionFragment'

export const workObstructionFragment: TypedDocumentNode<WorkObstructionFragment> = gql`
  fragment WorkObstructionFragment on WorkObstruction {
    city
    comment
    country {
      id
      nameEn
      nameFr
      nameNl
    }
    id
    processed
    risk
    street
    streetNumber
    weather
    workAndReason
    zip
  }
`
